import React, { useState } from 'react';
import { FolderIcon, FileIcon, VideoIcon, FileTextIcon, ImageIcon, ChevronRightIcon, DownloadIcon, EyeIcon, XIcon } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
interface Material {
  id: string;
  name: string;
  type: 'video' | 'pdf' | 'image' | 'document';
  size: string;
  date: string;
}
interface Folder {
  id: string;
  name: string;
  fileCount: number;
  materials: Material[];
}
const foldersData: Folder[] = [{
  id: '1',
  name: 'Climate Change 101',
  fileCount: 12,
  materials: [{
    id: '1-1',
    name: 'Introduzione al cambiamento climatico.mp4',
    type: 'video',
    size: '245 MB',
    date: '15 Dic 2024'
  }, {
    id: '1-2',
    name: 'Slide Lezione 1.pdf',
    type: 'pdf',
    size: '2.3 MB',
    date: '15 Dic 2024'
  }, {
    id: '1-3',
    name: 'Grafici temperatura globale.png',
    type: 'image',
    size: '890 KB',
    date: '15 Dic 2024'
  }]
}, {
  id: '2',
  name: 'Casa Efficiente',
  fileCount: 8,
  materials: [{
    id: '2-1',
    name: 'Isolamento termico.mp4',
    type: 'video',
    size: '189 MB',
    date: '10 Dic 2024'
  }, {
    id: '2-2',
    name: 'Guida risparmio energetico.pdf',
    type: 'pdf',
    size: '1.8 MB',
    date: '10 Dic 2024'
  }]
}, {
  id: '3',
  name: 'Mobilità Sostenibile',
  fileCount: 15,
  materials: [{
    id: '3-1',
    name: 'Trasporti pubblici vs auto.mp4',
    type: 'video',
    size: '312 MB',
    date: '5 Dic 2024'
  }, {
    id: '3-2',
    name: 'Calcolo emissioni CO2.pdf',
    type: 'pdf',
    size: '3.1 MB',
    date: '5 Dic 2024'
  }]
}, {
  id: '4',
  name: 'Risorse Community',
  fileCount: 24,
  materials: [{
    id: '4-1',
    name: 'Template report ESG.pdf',
    type: 'pdf',
    size: '1.2 MB',
    date: '1 Dic 2024'
  }, {
    id: '4-2',
    name: 'Checklist sostenibilità.pdf',
    type: 'pdf',
    size: '890 KB',
    date: '1 Dic 2024'
  }]
}];
const MaterialsPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>(null);
  const getFileIcon = (type: string) => {
    switch (type) {
      case 'video':
        return <VideoIcon size={20} className="text-red-600" data-id="element-2736" />;
      case 'pdf':
        return <FileTextIcon size={20} className="text-red-600" data-id="element-2737" />;
      case 'image':
        return <ImageIcon size={20} className="text-blue-600" data-id="element-2738" />;
      default:
        return <FileIcon size={20} className="text-gray-600" data-id="element-2739" />;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2740">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2741">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2742"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2743">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2744">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2745">
              <span className="sr-only" data-id="element-2746">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2747" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2748">
            <Sidebar activePage="formazione" data-id="element-2749" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2750">
        <Sidebar activePage="formazione" data-id="element-2751" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2752">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2753" />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-gray-50" data-id="element-2754">
          <div className="max-w-7xl mx-auto" data-id="element-2755">
            {/* Header */}
            <div className="mb-6" data-id="element-2756">
              <div className="flex items-center gap-2 text-sm text-gray-600 mb-2" data-id="element-2757">
                <button onClick={() => setSelectedFolder(null)} className="hover:text-gray-900 transition-colors" data-id="element-2758">
                  Materiali
                </button>
                {selectedFolder && <>
                    <ChevronRightIcon size={16} data-id="element-2759" />
                    <span className="text-gray-900 font-medium" data-id="element-2760">
                      {selectedFolder.name}
                    </span>
                  </>}
              </div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-2761">
                {selectedFolder ? selectedFolder.name : 'Materiali'}
              </h1>
              <p className="text-sm text-gray-600 font-normal" data-id="element-2762">
                {selectedFolder ? `${selectedFolder.fileCount} file disponibili` : 'Accedi a tutti i materiali dei corsi'}
              </p>
            </div>

            {/* Content */}
            {!selectedFolder /* Folders Grid */ ? <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-2763">
                {foldersData.map(folder => <button key={folder.id} onClick={() => setSelectedFolder(folder)} className="bg-white rounded-xl border border-gray-200 p-4 md:p-6 hover:border-green-600 hover:shadow-sm transition-all text-left" data-id="element-2764">
                    <div className="flex items-center justify-between mb-3 md:mb-4" data-id="element-2765">
                      <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-green-50 flex items-center justify-center" data-id="element-2766">
                        <FolderIcon size={20} className="text-green-600 md:hidden" data-id="element-2767" />
                        <FolderIcon size={24} className="text-green-600 hidden md:block" data-id="element-2768" />
                      </div>
                    </div>
                    <h3 className="font-medium text-gray-900 mb-1 text-sm md:text-base" data-id="element-2769">
                      {folder.name}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-500" data-id="element-2770">
                      {folder.fileCount} file
                    </p>
                  </button>)}
              </div> /* Files List */ : <div className="space-y-3" data-id="element-2771">
                {selectedFolder.materials.map(material => <div key={material.id} className="bg-white rounded-xl border border-gray-200 p-4 hover:border-green-600 transition-colors" data-id="element-2772">
                    <div className="flex items-center justify-between" data-id="element-2773">
                      <div className="flex items-center gap-3 flex-1" data-id="element-2774">
                        <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center flex-shrink-0" data-id="element-2775">
                          {getFileIcon(material.type)}
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-2776">
                          <h4 className="font-medium text-gray-900 truncate" data-id="element-2777">
                            {material.name}
                          </h4>
                          <div className="flex items-center gap-3 text-xs text-gray-500 mt-1" data-id="element-2778">
                            <span data-id="element-2779">{material.size}</span>
                            <span data-id="element-2780">•</span>
                            <span data-id="element-2781">{material.date}</span>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2782">
                        <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2783">
                          <EyeIcon size={18} className="text-gray-600" data-id="element-2784" />
                        </button>
                        <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2785">
                          <DownloadIcon size={18} className="text-gray-600" data-id="element-2786" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>}
          </div>
        </main>
      </div>
    </div>;
};
export default MaterialsPage;